import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';

import Gnb from '../../components/Gnb';
import NotFoundPage from '../NotFoundPage';

import numberFormat from '../../utils/numberFormat';
import { fetchWithJson } from '../../utils/api';
import openWithAppWithoutInstall from '../../utils/openWithAppWithoutInstall';

import getImageUrl from '../../utils/getImageUrl';

export class OldQRCodeLandPage extends Component {
  constructor(props) {
    super(props);
    this.handleOpenWithApp = this.handleOpenWithApp.bind(this);
  }

  componentDidMount() {
    const { device } = this.props;
    this.handleOpenWithApp();
  }

  handleOpenWithApp() {
    const { profile, device } = this.props;
    openWithAppWithoutInstall(
      device.getIn(['os', 'name']),
      process.env.REACT_APP_PF_CUSTOM_SCHEME,
      `plusfriend/home/${profile.get('uuid')}/add`,
      'com.kakao.talk'
    );
  }

  render() {
    const { device, profile } = this.props;
    if (!profile) {
      return null;
    }
    const { name, profileImage, statusMessage, uuid, spamLevel, isOfficial, isFriend } = profile;
    if (spamLevel === 5) {
      return ( <RestrictFriendPage profile={profile} device={device} />)
    }

    return (
      <center>
        <div className="main">
          <div className="contents">
            <div className="banner" />
            <div id="add_friend">
              <div className="title">카카오톡 채널로<br/>추가해보세요.</div>
              <div className="content">
                아래 '채널 추가' 버튼을 누르시면<br/>카카오톡 친구 추가 화면으로 이동합니다.
              </div>
              <div className="pf_info" style={{ marginTop: '10px' }}>
                <div className="pf_content">
                  <img alt="" className="profile_image" src={getImageUrl(profileImage.get('mediumUrl'))} />
                  <div className="profile_text">
                    <span className="title">{name}</span><br/>
                    <span className="uuid">{uuid}</span>
                  </div>
                </div>
              </div>
              <div className="btn_container" style={{margin: '10px 0 40px 0'}}>
                <a id="btn_add_friend" href="#" className="button type1" onClick={this.handleOpenWithApp}>
                  <span>친구 추가</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </center>
    );
  }
}

const mapStateToProps = (state, { match: { params: { uuid } } } ) => {
  const { entities, profile, device } = state;
  const profiles = entities.get('profiles', Immutable.Map());
  const selectedProfile = fillDetails(profiles.first(), entities);
  return { profile: selectedProfile, device };
};

export default connect(
  mapStateToProps, (dispatch) => bindActionCreators({}, dispatch)
)(OldQRCodeLandPage);



// WEBPACK FOOTER //
// ./src/containers/OldQRCodeLandPage/index.js